const BaseView = require('../../components/common/common-component');
const ViewTemplate = require('./view.hbs');
const GradientsListTemplate = require('./gradients-list.hbs');
const EditorView = require('./editor');
import GradientHelpers from '../../../../gradients/gradient-helpers';
import LinearGradient from '../../../../gradients/linear-gradient';
import RadialGradient from '../../../../gradients/radial-gradient';

module.exports = BaseView.extend({

  events: {
    ...BaseView.prototype.events,
    'click #btn-add-linear': 'onAddLinearGradient',
    'click #btn-add-radial': 'onAddRadialGradient',
    'click rect[data-gradient-id]': 'onEditLinearGradient',
    'click circle[data-gradient-id]': 'onEditRadialGradient',
  },

  show: function () {
    if (this.isAlreadyThere) {
      this.onRefresh();
    } else {
      BaseView.prototype.initialize.call(this);
      this.isAlreadyThere = true;
      this.render();
    }
  },

  render: function () {
    this.$el.html(ViewTemplate({}));
    this.onRefresh();
  },

  onRefresh: function () {
    const gradients = GradientHelpers.getGradientsList();
    const linearGradients = gradients.linearGradients;
    const radialGradients = gradients.radialGradients;

    const $gradientsList = this.$el.find('.gradients-library');
    $gradientsList.html(GradientsListTemplate({ linearGradients, radialGradients }));
  },

  onAddLinearGradient: function () {
    GradientHelpers.addGradient(new LinearGradient());
    this.onRefresh();
  },

  onAddRadialGradient: function () {
    GradientHelpers.addGradient(new RadialGradient());
    this.onRefresh();
  },

  onEditGradient: function (event, isLinear) {
    const gradientId = event.target.getAttribute('data-gradient-id');
    const $view = $('<div></div>');
    $('body').append($view);
    const editorView = new EditorView({ el: $view });
    editorView.gradientId = gradientId;
    editorView.isLinear = isLinear;
    editorView.onCloseEditor = this.onCloseEditor.bind(this);
    editorView.show();
  },

  onEditLinearGradient: function (event) {
    this.onEditGradient(event, true);
  },

  onEditRadialGradient: function (event) {
    this.onEditGradient(event, false);
  },

  onCloseEditor: function (refreshRequired) {
    document.querySelector('#gradients-editor').parentElement.remove();
    refreshRequired && this.onRefresh();
  }
});
